import React from 'react';
import { SortDownIcon, SortUpIcon } from '../icons';
import { StyledTHSortIcon } from './THSort.styled';
export var sortDirections = /*#__PURE__*/function (sortDirections) {
  sortDirections["ascending"] = "asc";
  sortDirections["descending"] = "desc";
  return sortDirections;
}({});
export function SortIcon(props) {
  var isAscending = props.sortParams.direction === sortDirections.ascending;
  return /*#__PURE__*/React.createElement(StyledTHSortIcon, null, props.sortKey === props.sortParams.key && (isAscending ? /*#__PURE__*/React.createElement(SortUpIcon, null) : /*#__PURE__*/React.createElement(SortDownIcon, null)));
}